import { CalculateVenueEnv } from '@/domain/impact-calculate-venue/entities/calculate-venue-env.entity';
import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';
import { TopicScoreDetailsData } from '@/ui/pages/app/components/topic-score-card/type';
import {
  formatUnit,
  getEnvSectionName,
  getEnvTopicName,
} from '@/ui/utils/ess-env-names-and-format';

export function prepareVenueTopicScoreDetailsDataEnv(
  calculateVenue: CalculateVenueEnv,
): TopicScoreDetailsData {
  const structureEnvScore = calculateVenue.structure;
  return {
    scoreLetter: structureEnvScore.scoreLetter,
    value: structureEnvScore.score,
    refValue: NaN,
    maxValue: structureEnvScore.maxScore,
    completion: NaN,
    sections: [
      {
        name: getEnvTopicName(EnvTopic.FOOD_BEVERAGES),
        score: structureEnvScore.topics.FOOD_BEVERAGES.score,
        maxScore: structureEnvScore.topics.FOOD_BEVERAGES.maxScore,
        items: [
          {
            id: 'FOOD_BEVERAGES-CATERING',
            name: getEnvSectionName(EnvSection.CATERING),
            value:
              structureEnvScore.topics.FOOD_BEVERAGES.sections.CATERING.score,
            unit: formatUnit(
              structureEnvScore.topics.FOOD_BEVERAGES.sections.CATERING
                .maxScore,
            ),
          },
          {
            id: 'FOOD_BEVERAGES-BEVERAGES',
            name: getEnvSectionName(EnvSection.BEVERAGES),
            value:
              structureEnvScore.topics.FOOD_BEVERAGES.sections.BEVERAGES.score,
            unit: formatUnit(
              structureEnvScore.topics.FOOD_BEVERAGES.sections.BEVERAGES
                .maxScore,
            ),
          },
          {
            id: 'FOOD_BEVERAGES-DISHES',
            name: getEnvSectionName(EnvSection.DISHES),
            value:
              structureEnvScore.topics.FOOD_BEVERAGES.sections.DISHES.score,
            unit: formatUnit(
              structureEnvScore.topics.FOOD_BEVERAGES.sections.DISHES.maxScore,
            ),
          },
        ],
      },
      {
        name: getEnvTopicName(EnvTopic.RESOURCES_POLLUTION),
        score: structureEnvScore.topics.RESOURCES_POLLUTION.score,
        maxScore: structureEnvScore.topics.RESOURCES_POLLUTION.maxScore,
        items: [
          {
            id: 'RESOURCES_POLLUTION-WATER',
            name: getEnvSectionName(EnvSection.WATER),
            value:
              structureEnvScore.topics.RESOURCES_POLLUTION.sections.WATER.score,
            unit: formatUnit(
              structureEnvScore.topics.RESOURCES_POLLUTION.sections.WATER
                .maxScore,
            ),
          },

          {
            id: 'RESOURCES_POLLUTION-ENERGY',
            name: getEnvSectionName(EnvSection.ENERGY),
            value:
              structureEnvScore.topics.RESOURCES_POLLUTION.sections.ENERGY
                .score,
            unit: formatUnit(
              structureEnvScore.topics.RESOURCES_POLLUTION.sections.ENERGY
                .maxScore,
            ),
          },
          {
            id: 'RESOURCES_POLLUTION-WASTE_ECODESIGN',
            name: getEnvSectionName(EnvSection.WASTE_ECODESIGN),
            value:
              structureEnvScore.topics.RESOURCES_POLLUTION.sections
                .WASTE_ECODESIGN.score,
            unit: formatUnit(
              structureEnvScore.topics.RESOURCES_POLLUTION.sections
                .WASTE_ECODESIGN.maxScore,
            ),
          },
          {
            id: 'RESOURCES_POLLUTION-POLLUTION_LOCATION',
            name: getEnvSectionName(EnvSection.POLLUTION_LOCATION),
            value:
              structureEnvScore.topics.RESOURCES_POLLUTION.sections
                .POLLUTION_LOCATION.score,
            unit: formatUnit(
              structureEnvScore.topics.RESOURCES_POLLUTION.sections
                .POLLUTION_LOCATION.maxScore,
            ),
          },
        ],
      },
      {
        name: getEnvTopicName(EnvTopic.COMMUNICATION),
        score: structureEnvScore.topics.COMMUNICATION.score,
        maxScore: structureEnvScore.topics.COMMUNICATION.maxScore,
        items: [
          {
            id: 'COMMUNICATION-PHYSICAL_COMMUNICATION',
            name: getEnvSectionName(EnvSection.PHYSICAL_COMMUNICATION),
            value:
              structureEnvScore.topics.COMMUNICATION.sections
                .PHYSICAL_COMMUNICATION.score,
            unit: formatUnit(
              structureEnvScore.topics.COMMUNICATION.sections
                .PHYSICAL_COMMUNICATION.maxScore,
            ),
          },
          {
            id: 'COMMUNICATION-DIGITAL_COMMUNICATION',
            name: getEnvSectionName(EnvSection.DIGITAL_COMMUNICATION),
            value:
              structureEnvScore.topics.COMMUNICATION.sections
                .DIGITAL_COMMUNICATION.score,
            unit: formatUnit(
              structureEnvScore.topics.COMMUNICATION.sections
                .DIGITAL_COMMUNICATION.maxScore,
            ),
          },
        ],
      },
      {
        name: getEnvTopicName(EnvTopic.PUBLIC_ENGAGEMENT),
        score: structureEnvScore.topics.PUBLIC_ENGAGEMENT.score,
        maxScore: structureEnvScore.topics.PUBLIC_ENGAGEMENT.maxScore,
        items: [
          {
            id: 'PUBLIC_ENGAGEMENT-MOBILITY_STRATEGY',
            name: getEnvSectionName(EnvSection.MOBILITY_STRATEGY),
            value:
              structureEnvScore.topics.PUBLIC_ENGAGEMENT.sections
                .MOBILITY_STRATEGY.score,
            unit: formatUnit(
              structureEnvScore.topics.PUBLIC_ENGAGEMENT.sections
                .MOBILITY_STRATEGY.maxScore,
            ),
          },
          {
            id: 'PUBLIC_ENGAGEMENT-PUBLIC_INFORMATION',
            name: getEnvSectionName(EnvSection.PUBLIC_INFORMATION),
            value:
              structureEnvScore.topics.PUBLIC_ENGAGEMENT.sections
                .PUBLIC_INFORMATION.score,
            unit: formatUnit(
              structureEnvScore.topics.PUBLIC_ENGAGEMENT.sections
                .PUBLIC_INFORMATION.maxScore,
            ),
          },
        ],
      },
    ],
  };
}
